import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export const EASE = [0.76, 0, 0.24, 1];

export const LineReveal = ({ lines, className = '', lineClassName = '', delay = 0.1, stagger = 0.14 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden">
        <motion.div
          className={lineClassName}
          initial={{ y: '115%' }}
          animate={{ y: '0%' }}
          transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export const FadeIn = ({ children, delay = 0, y = 32, className = '', once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: '-60px' }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const ParallaxImage = ({ src, alt = '', className = '', speed = 0.15, imgClassName = '' }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y, scale: 1 + speed * 2 }}
        className={`w-full h-full object-cover ${imgClassName}`}
      />
    </div>
  );
};
